// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609281734/js/" + chunkId + "." + {"44":"5a15e1c7","225":"b1129105","481":"02fa4bd7","486":"f3941f7e","770":"3e839f5f"}[chunkId] + ".0.13946990058128061.chunk.js";
};